// extracted by mini-css-extract-plugin
module.exports = {"status":"styles_status___g068","statusActivation":"styles_statusActivation__6mnzL","statusReview":"styles_statusReview__3teU0"};